module.exports = __webpack_public_path__ + "static/media/Template_14.21be536a.png";